<template>
    <div class="login">
      <h2>用户登录</h2>
      <input v-model="username" placeholder="请输入用户名" />
      <button @click="login">登录</button>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { Base64 } from 'js-base64';
  export default {
    name: 'Login',
    data() {
      return {
        username: ''
      }
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      const authInfo = urlParams.get('authinfo');
      console.log(authInfo,window.location.href);
      if(authInfo) {
        let authinfo = Base64.decode(authInfo);
        authinfo = JSON.parse(authinfo)
        this.authlogin(authinfo)
      }
      
    },
    methods: {
      authlogin(authinfo) {
        authinfo.username = 'move'
        axios.post('/gapi/api/login', authinfo)
          .then(res => {
            localStorage.setItem('user', JSON.stringify(res.data.user));
            // 登录后跳转到模式选择页
            this.$router.replace('/mode');
          })
          .catch(err => {
            console.error(err);
            alert('登录失败');
        });
      },
      login() {
        if (!this.username) {
          alert('请输入用户名');
          return;
        }
        axios.post('/gapi/api/login', { username: this.username })
          .then(res => {
            localStorage.setItem('user', JSON.stringify(res.data.user));
            // 登录后跳转到模式选择页
            this.$router.replace('/mode');
          })
          .catch(err => {
            console.error(err);
            alert('登录失败');
          });
      }
    }
  }
  </script>
  
  <style scoped>
  .login {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
  }
  .login input {
    margin: 10px 0;
    padding: 10px;
    font-size: 16px;
  }
  .login button {
    padding: 10px 20px;
    font-size: 16px;
  }
  </style>
  